import React from 'react';

import { UserKpiStyleProps } from '../../types';

export const UserKpiStyle: React.FC<UserKpiStyleProps> = () => {
    return <div />;
};
